import { BasicsBaseApiV2 } from "../BasicsBaseApiV2";

export class ActreflowConditionApi extends BasicsBaseApiV2 {

    public get ControllerName(): any {
        return 'actreflowCondition';
    }

}